import { printCalendar } from "./printCalendar.js";


function init() {
    printCalendar();
}

export {
    init   
}